
<!-- <div class="footerTopBg"></div> -->

<div class="container-fluid footerBg p-0">  
    <div class="dark-grey-bg">
        <div class="max-page-width">
            <div class="footerLinks">
                <div class="row p-0">
                    <div class="col-lg-6 col-md-7 pt-2">
                        <ul class="footer-links">
                            <li *ngIf="AboutUsContent != null"><a routerLink="/About-Us">{{ 'AboutUs' | translate }}</a></li>
                            <li *ngIf="ServiceTermsContent != null"><a routerLink="/Service-Terms-And-Condition">{{ 'ServiceTerms' | translate }}</a></li>
                            <li><a routerLink="/Contact-Us">{{ 'ContactUs' | translate }}</a></li>
                            <li *ngIf="FAQContent != null"><a routerLink="/FAQ">{{ 'FAQ' | translate }}</a></li>
                            <li *ngIf="PrivacyPolicyContent != null"><a routerLink="/Privacy-Policy">{{ 'PrivacyPolicy' | translate }}</a></li>
                        </ul>
                        
                    </div>

                    <div class="col-lg-6 col-md-5 footerIcons">
                        

                        <!-- <div  *ngFor="let item of SocialLinks" >    
                            <div [innerHTML]="item.contentText | translate"></div>
                        </div> -->
                      
                            <div *ngIf="facbookURL != null" class="footerIcon"><a target="_blank" [href]="facbookURL.contentText"><i class="fab fa-facebook-f">&nbsp;</i></a></div>
                            <div *ngIf="instagramURL != null" class="footerIcon"><a target="_blank" [href]="instagramURL.contentText"><i class="fab fa-instagram">&nbsp;</i></a></div>
                            <div *ngIf="twitterURL != null" class="footerIcon"><a target="_blank" [href]="twitterURL.contentText"><i class="fab fa-twitter">&nbsp;</i></a></div>
                            <div *ngIf="linkedinURL != null" class="footerIcon"><a target="_blank" [href]="linkedinURL.contentText"><i class="fab fa-linkedin">&nbsp;</i></a></div>
                            <div *ngIf="googleURL != null" class="footerIcon"><a target="_blank" [href]="googleURL.contentText"><i class="fab fa-google">&nbsp;</i></a></div>
                   
                    </div>
                </div>
            </div>
        </div>   
    </div>   
    <!-- <div class="footerChat"><fa-icon [icon]="faComments"></fa-icon></div> -->
    <div class="white-bg">
        <div class="max-page-width"> 
            <div class="footerCopyrights">
                GCU365 © {{year}}. {{ 'AllRightsReserved2' | translate }}
            </div>
        </div>
    </div>
</div>

